import { render, staticRenderFns } from "./SolutionPart.vue?vue&type=template&id=45b0fcf4&scoped=true&"
import script from "./SolutionPart.vue?vue&type=script&lang=js&"
export * from "./SolutionPart.vue?vue&type=script&lang=js&"
import style0 from "./SolutionPart.vue?vue&type=style&index=0&id=45b0fcf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0fcf4",
  null
  
)

export default component.exports